/** Color components that only make sense when custom side patches are fully active. */
export const SIDE_PATCH_COLOR_COMPONENT_IDS = ["patch-material-sides", "customText-material-sides"];

/**
 * Side logos share the sidePatches-itemGroup node with custom side patches, so when they
 * are on their own MeshController owns visibility for that group.
 */
export function isSideLogoActive({ itemsState }) {
  return itemsState?.activeObjs?.["side-logo"]?._id === "yes-side-logos";
}

/**
 * Side patches are all-or-nothing: custom text selected, side logos off, and the
 * product allows side patches. Used by cart, scene, and price so they cannot diverge.
 */
export function isSidePatchActive({ itemsState, productsState }) {
  if (productsState?.activeObj?.shopify?.["omit-side-patches"] === true) return false;
  if (isSideLogoActive({ itemsState })) return false;
  return itemsState?.activeObjs?.["custom-patches-side"]?._id === "customText-side-patches";
}
